import {Injectable} from '@angular/core';
import {ApiService} from './api.service';
import {Observable} from 'rxjs';

export type Report = {
  year: number;
  total: number;
  number: number;
  months: {
    num: number;
    name: string;
    total: number;
    number: number;
    categories: {
      id: string;
      name: string;
      total: number;
      number: number;
      plans: {
        id: string;
        name: string;
        total: number;
        number: number;
      }[]
    }[]
  }[];
}[];

@Injectable()
export class ReportService {
  constructor(private readonly apiService: ApiService) {
  }

  get(): Observable<Report> {
    return this.apiService.get(`/reports/all`);
  }

  categoryByYear(categoryId: string, year: number) {
    return this.apiService.get(`/reports/category/${categoryId}/year/${year}`);
  }

  categoryByMonth(categoryId: string, year: number, month: number) {
    return this.apiService.get(`/reports/category/${categoryId}/year/${year}/month/${month}`);
  }

  categoryByDay(categoryId: string, year: number, month: number, day: number) {
    return this.apiService.get(`/reports/category/${categoryId}/year/${year}/month/${month}/day/${day}`);
  }

  planByYear(planId: string, year: number) {
    return this.apiService.get(`/reports/plan/${planId}/year/${year}`);
  }

  planByMonth(planId: string, year: number, month: number) {
    return this.apiService.get(`/reports/plan/${planId}/year/${year}/month/${month}`);
  }

  planByDay(planId: string, year: number, month: number, day: number) {
    return this.apiService.get(`/reports/plan/${planId}/year/${year}/month/${month}/day/${day}`);
  }

}
